export const clientVersion = '2026-10-27';
